import { onRequest } from '../..';
import { ActionsType, PropertyType } from '../../../common';
import { addNewGameProvider } from '../../../api/endpoints/addNewGameProvider';
import { validateForm, validateProvidersForm } from '../../../view/pages/GameProviders/GameProviders.helper';
import { getCasinoGameProviders } from '../../../api/endpoints/getCasinoGameProviders';
import { GameProviderFormKey } from '../../../view/pages/GameProviders/GameProviders.const';
import { getCasinoGamePartners } from '../../../api/endpoints/getCasinoGamePartners';
import { assignProviderToPartner } from '../../../api/endpoints/assignProviderToPartner';
import { getCasinoGameProvider } from '../../../api/endpoints/getCasinoGameProvider';

const gameProvidersInit = async (payload: PropertyType) => {
	const { token, page, perPage } = payload;
	const { gameProviders, pagesTotal } = await getCasinoGameProviders({ token, page, query: '', perPage });
	return { gameProviders: gameProviders, bulkRows: [], pagesTotal, currentPage: page, gamesLoading: false };
};

// const gameProviderInit = async (state: PropertyType, payload: PropertyType) => {
// 	const { token, id } = payload;
// 	const { gameCategory } = await getCasinoGameProvider({ token, id });
//
// 	const gameProvidersData = {
// 		game_name: gameCategory.name,
// 		game_id: gameCategory.id,
// 	};
//
// 	return { gamesLoading: false, gameCategoryForm: gameProvidersData };
// };

const onPageUpdate = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, perPage } = payload;
	const { gameProviders, pagesTotal } = await getCasinoGameProviders({ token, page, query: '', perPage });
	return { gameProviders: gameProviders, bulkRows: [], pagesTotal, currentPage: page, gamesLoading: false };
};
//
// const onGameToggle = async (payload: PropertyType) => {
// 	const { token, page } = payload;
// 	const data = await getCasinoGames({ token, page, query: '' });
//
// 	return { data };
// };
//
// const onUpdateCategoryForm = (state: PropertyType, payload: PropertyType) => {
// 	const { categories } = payload;
// 	return { categoryForm: { categories: categories } };
// };

const formReset = () => {
	return {
		gameFormProvider: {
			game_name: '',
		},
	};
};
//
const onGameProviderAdd = async (state: PropertyType, payload: PropertyType) => {
	const { token, gameProviderForm } = payload;
	const formErrors = validateForm(gameProviderForm);
	const gameProviders = [...state.gameProviders];
	let responesMsg = '';
	if (formErrors) {
		return { formErrors };
	} else {
		if (state?.selectedGameProvider?.id) {
			// const { gameProvider, message } = await editGameProvider({
			// 	token,
			// 	gameProviderForm: { ...gameProviderForm, game_id: state.selectedGameCategory.id },
			// });
			// responesMsg = message;
			// const editIndex = findIndex(gameProviders, ['game_id', state.selectedGameCategory.id]);
			// gameProviders[editIndex] = gameProvider;
		} else {
			const { gameProvider, message } = await addNewGameProvider({ token, gameProviderForm });
			responesMsg = message;
			gameProviders.unshift(gameProvider);
		}
		return {
			globalSuccess: responesMsg,
			gameProviders,
		};
	}
};
//
const onUpdateForm = (state: PropertyType, payload: PropertyType) => {
	const { field, value } = payload;
	const newForm = { ...state.gameProviderForm, [field]: value };
	const errors = validateForm(newForm);
	const fieldError = errors ? errors[field as GameProviderFormKey] : null;

	return {
		gameProviderForm: newForm,
		formErrors: { ...state.formErrors, [field]: fieldError },
	};
};

const onUpdatePartnerForm = (state: PropertyType, payload: PropertyType) => {
	const { field, value } = payload;
	const newForm = { ...state.gameProviderPartnerForm, [field]: value };
	const errors = validateProvidersForm(newForm);
	const fieldError = errors ? errors[field as GameProviderFormKey] : null;

	return {
		gameProviderPartnerForm: newForm,
		formErrors: { ...state.formErrors, [field]: fieldError },
	};
};

// const onGameTCategory = async (payload: PropertyType) => {
// 	const { token, filters } = payload;
// 	const resp = await getFilterOptions({ token, filters });
//
// 	return { ...resp.data };
// };
// //
const onGameProviderSelect = async (payload: PropertyType) => {
	const { gameProvider } = payload;

	return {
		selectedGameProvider: gameProvider,
		gameProviderForm: {
			game_provider_id: '',
			game_provider_name: '',
			active: '',
		},
		gameProviderPartnerForm: {
			short_name_test: '',
			short_name_live: '',
		},
		activePartners: [],
	};
};

const getAllPartners = async (payload: PropertyType) => {
	const { token, page } = payload;
	const perPage = 1000;
	const resp = await getCasinoGamePartners({ token, page, query: '', perPage });
	return { allSkins: resp };
};

const partnersInit = (user: PropertyType) => {
	const { partners } = user;

	return { partners };
};

const onAssignGamePartners = async (payload: PropertyType) => {
	const { token, form, provider, partner } = payload;
	const resp = await assignProviderToPartner({ token, form, provider, partner });

	return { ...resp.data };
};

const formAssignPartnerReset = () => {
	return {
		gameProviderPartnerForm: {
			short_name_test: '',
			short_name_live: '',
		},
		activePartners: [],
	};
};

const getProviderDetails = async (payload: PropertyType) => {
	const { token, gameProvider } = payload;
	const resp = await getCasinoGameProvider({ token, gameProvider });
	return { selectedGameProvider: resp };
};

const onFilter = async (state: PropertyType, payload: PropertyType) => {
	const { token, page, filters } = payload;

	return filterData(token, page, filters, state.perPage);
};

const filterData = async (token: string, page: string, filters: PropertyType[], perPage: string) => {
	const query = filters.length ? getFiltersUrl(filters) : '';
	const data = await getCasinoGameProviders({ token, page, query, perPage });

	return {
		...data,
		filters,
		filtering: filters.length > 1,
		bulkRows: [],
		currentPage: page,
		gamesLoading: false,
	};
};

const getFiltersUrl = (filters: PropertyType[]) => {
	const urlFragments = filters.map((f) => {
		const name = f.name === 'checksumStatuses' ? 'checksum_last_statuses' : f.name;
		return `${name}=${f.value}`;
	});

	return `?${urlFragments.join('&')}`;
};

export const actions: ActionsType = {
	GAME_PROVIDERS_INIT: (state, payload) => onRequest(() => gameProvidersInit(payload), true),
	// GAME_PROVIDER_INIT: (state, payload) => gameProviderInit(state, payload),
	LOADING: (state, payload) => ({ gamesLoading: payload }),
	PAGE_UPDATE: (state, payload) => onRequest(() => onPageUpdate(state, payload), true),
	PER_PAGE: (state, payload) => ({ perPage: payload }),
	UPDATE_COLUMNS: (state, payload) => ({ columns: payload }),
	SELECT_GAME_PROVIDER: (state, payload) => onGameProviderSelect(payload),
	UPDATE_ROWS: (state, payload) => ({ rows: payload }),
	GAME_PROVIDER_ADD: (state, payload) => onGameProviderAdd(state, payload),
	FORM: (state, payload) => onUpdateForm(state, payload),
	PARTNERS_FORM: (state, payload) => onUpdatePartnerForm(state, payload),
	FORM_RESET: () => formReset(),
	SAVING: (state, payload) => ({ savingData: payload }),
	GLOBAL_ERROR: (state, payload) => ({ globalErrors: payload }),
	GLOBAL_SUCCESS: (state, payload) => ({ globalSuccess: payload }),
	MESSAGE_INVALIDATE: () => ({ globalErrors: [], globalSuccess: '', formErrors: '', usersLoading: false }),
	GET_PARTNERS: (state, payload) => onRequest(() => getAllPartners(payload), true),
	PARTNERS_INIT: (state, payload) => partnersInit(payload),
	PARTNERS_UPDATE: (state, payload) => ({ activePartners: payload }),
	PROVIDER_PARTNER_ASSIGN: (state, payload) => onAssignGamePartners(payload),
	FORM_ASSIGN_PARTNER_RESET: () => formAssignPartnerReset(),
	GET_PROVIDER: (state, payload) => getProviderDetails(payload),
	FILTER: (state, payload) => onFilter(state, payload),
};
